import React from "react";

export default function SupportPage() {
    return (
        <div
            style={{
                maxWidth: "900px",
                margin: "0 auto",
                padding: "40px 20px",
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#111"
            }}
        >
            <h1>Soporte Alecom</h1>
            <p>
                Bienvenido al centro de soporte de <strong>Alecom</strong>.
                Si necesitas ayuda con la aplicación, acceso a tu cuenta o reportar un problema,
                puedes contactarnos por los siguientes medios.
            </p>

            <hr />

            <h2>Contacto</h2>
            <p><strong>Correo:</strong> soporte@tudominio.com</p>
            <p><strong>Horario:</strong> Lunes a Viernes de 9:00 a 18:00 hrs</p>

            <h2>Ayuda frecuente</h2>

            <h3>No puedo iniciar sesión</h3>
            <p>
                Verifica tu correo y contraseña. Si olvidaste tus datos,
                contacta al administrador o soporte.
            </p>

            <h3>No veo mis documentos</h3>
            <p>
                Los documentos disponibles dependen del inmueble asignado
                a tu cuenta. Si falta alguno, solicita revisión al administrador.
            </p>

            <h3>Error en la aplicación</h3>
            <p>
                Escríbenos indicando modelo del dispositivo, sistema operativo
                y una breve descripción del problema.
            </p>

            <h2>Privacidad</h2>
            <p>
                Consulta nuestra Política de Privacidad en:
            </p>
            <p>
                <a href="/privacy">/privacy</a>
            </p>

            <hr />

            <p style={{ color: "#666", marginTop: "30px" }}>
                © 2026 Alecom. Todos los derechos reservados.
            </p>
        </div>
    );
}